import React from 'react';
import { useCostsAndFeesContext } from 'app/shared/modules/hdp/CostsAndFees/context/CostsAndFeesProvider';
import Card from '../../../ui/Card';
import * as styles from './costAndFeesModule.styles';

const getMinAmount = (amount: { displayText: string } | { min: number; max: number | null } | undefined): number => {
  if (!amount || !('min' in amount)) return 0;
  return amount.min;
};

const getMaxAmount = (amount: { displayText: string } | { min: number; max: number | null } | undefined): number => {
  if (!amount || !('min' in amount)) return 0;
  return typeof amount.max === 'number' ? amount.max : amount.min;
};

export const CostSummaryCard = () => {
  const { calculatedCostsAndFees, getDisplayAmount } = useCostsAndFeesContext();

  if (!calculatedCostsAndFees?.costs) return null;

  const { costs } = calculatedCostsAndFees;
  const monthlyMin = getMinAmount(costs.monthly?.amount);
  const moveInMin = getMinAmount(costs.moveIn?.amount);
  const monthlyMax = getMaxAmount(costs.monthly?.amount);
  const moveInMax = getMaxAmount(costs.moveIn?.amount);
  const totalAmount = getDisplayAmount({ min: monthlyMin + moveInMin, max: monthlyMax + moveInMax });
  const monthlyAmount = getDisplayAmount(costs.monthly?.amount);
  const moveInAmount = getDisplayAmount(costs.moveIn?.amount);

  return (
    <Card variant="default" size="md">
      <div className={styles.totalAmount}>{totalAmount}</div>
      <div className={styles.totalLabel}>Est. total move in cost</div>
      <div className={styles.summaryRow}>
        <span className={styles.summaryLabel}>Monthly rent & fees</span>
        <span className={styles.summaryValue}>{monthlyAmount}</span>
      </div>
      <div className={styles.summaryRow}>
        <span className={styles.summaryLabel}>One-time fees</span>
        <span className={styles.summaryValue}>{moveInAmount}</span>
      </div>
    </Card>
  );
};
